import { render, staticRenderFns } from "./Ablauf.vue?vue&type=template&id=2fc20aa5&"
import script from "./Ablauf.vue?vue&type=script&lang=js&"
export * from "./Ablauf.vue?vue&type=script&lang=js&"
import style0 from "./Ablauf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports